import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { WbGrid, WbTab, WbTabs } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import { VimdtModalHost } from './Common/VimdtModal';
import { ImageProvider } from '../../Contexts/ImageContext';
import './VimdtLayout.scss';

const TABS = [
	{ path: '/images', labelKey: 'vimdt.imagesTab.imagesTabName' },
	{ path: '/equipments', labelKey: 'vimdt.equipmentsTab.equipmentsTabName' },
	{ path: '/specification', labelKey: 'vimdt.specificationsTab.specificationsTabName' },
	{ path: '/models', labelKey: 'vimdt.modelsTab.modelsTabName' },
];

/**
 * Shared shell for the vehicle-images routes: tab navigation plus the state that
 * has to survive switching between tabs.
 */
function VimdtLayout() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const selected = TABS.find((tab) => pathname.startsWith(tab.path))?.path || TABS[0].path;

	return (
		<ImageProvider>
			<WbGrid className="vimdt-layout">
				<WbTabs
					selected={selected}
					onWbchange={(event) => {
						const next = event.detail?.name ?? event.detail;
						if (next && next !== selected) navigate(next);
					}}
				>
					{TABS.map((tab) => (
						<WbTab key={tab.path} name={tab.path}>
							{t(tab.labelKey)}
						</WbTab>
					))}
				</WbTabs>

				<div className="vimdt-layout__content">
					<Outlet />
				</div>
			</WbGrid>
			<VimdtModalHost />
		</ImageProvider>
	);
}

export default VimdtLayout;
